import React from 'react';
import { Size } from '@vtblife/uikit/dist/legacy';
import { getStepFieldName } from '../../utils/step-field';
import { FormikCheckboxGroupField } from '../formik-checkbox-group-field/formik-checkbox-group-field';
import { FormikRadioGroupField } from '../formik-radio-group-field/formik-radio-group-field';
import { FormikRatingField } from '../formik-rating-field/formik-rating-field';
import { FormikSelectRegionField } from '../formik-select-region-field';
export function FieldRender(step) {
    var _a, _b;
    const fieldName = getStepFieldName(step);
    if (step.type === 'radio-group' && ((_a = step.field) === null || _a === void 0 ? void 0 : _a.options)) {
        return (React.createElement(FormikRadioGroupField, { name: fieldName, label: step.field.label, size: Size.Large, options: step.field.options, ownAnswer: step.ownAnswer, button: true, block: true, hideNoteSpace: true }));
    }
    if (step.type === 'checkbox-group' && ((_b = step.field) === null || _b === void 0 ? void 0 : _b.options)) {
        return (React.createElement(FormikCheckboxGroupField, { name: fieldName, label: step.field.label, options: step.field.options, ownAnswer: step.ownAnswer, button: true, block: true, hideNoteSpace: true }));
    }
    if (step.type === 'rating' && step.ratingSettings) {
        return (React.createElement(FormikRatingField, { button: true, block: true, hideNoteSpace: true, name: step.ratingSettings.name || ' ', label: step.ratingSettings.label, commentForRating: step.ratingSettings.commentForRating, variant: step.ratingSettings.variant, maxRatingText: step.ratingSettings.maxRatingText, minRatingText: step.ratingSettings.minRatingText }));
    }
    if (step.type === 'select-region' && step.selectRegionSettings) {
        return React.createElement(FormikSelectRegionField, { name: fieldName });
    }
    return null;
}
//# sourceMappingURL=field-render.js.map